import React from 'react';
import {
	IonMenu,
	IonHeader,
	IonToolbar,
	IonTitle,
	IonContent,
	IonLabel,
	IonItem,
	IonList,
	IonIcon,
} from '@ionic/react';
import { connect } from 'react-redux';
import { homeOutline, informationCircleOutline, phonePortraitOutline, cartOutline } from 'ionicons/icons';
import { RootState } from '../store';
import LoggedInMenuItems from './LoggedInMenuItems';
import LoggedOutMenuItems from './LoggedOutMenuItems';

type ProfileMenuProps = ReturnType<typeof mapStateToProps>;

const renderMenuItems = (isLoggedIn: boolean) => {
	return isLoggedIn ? <LoggedInMenuItems /> : <LoggedOutMenuItems />;
}

const ProfileMenu: React.FC<ProfileMenuProps> = ({ isLoggedIn }) => (
	<IonMenu side="start" contentId="main" type="push">
		<IonHeader>
			<IonToolbar>
				<IonToolbar color="primary">
					<IonTitle>Menu</IonTitle>
				</IonToolbar>
			</IonToolbar>
		</IonHeader>
		<IonContent>
			<IonList>
				<IonItem routerLink="../../../places">
					<IonLabel >
					<IonIcon icon={homeOutline} /> Home
					</IonLabel>
				</IonItem>
				{renderMenuItems(isLoggedIn)}
				<IonItem routerLink="../../../about">
					<IonLabel >
						<IonIcon icon={informationCircleOutline}></IonIcon> About Us
					</IonLabel>
				</IonItem>
				<IonItem routerLink="../../../contactus">
					<IonLabel >
						<IonIcon icon={phonePortraitOutline}></IonIcon> Contact Us
					</IonLabel>
				</IonItem>
				<a target="_blank" style={{"textDecoration": "none"}} href="https://teespring.com/stores/parklers">
					<IonItem>
						<IonLabel >
							<IonIcon icon={cartOutline}></IonIcon> Shop our Merch
						</IonLabel>
					</IonItem>
				</a>
				<form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
					<input type="hidden" name="cmd" value="_donations" />
					<input type="hidden" name="business" value="M8MKDUXW862GQ" />
					<input type="hidden" name="currency_code" value="USD" />
					<IonItem>
						<IonLabel>
							<input
								type="image"
								style={{"width": "20px", "height": "20px", "margin": "0px"}}
								src="../../../../data/paypal2.png"
								name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal" />
								<button className="paypal" type="submit"><IonLabel>Donate with Paypal</IonLabel></button>
							<img alt="" src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1" />
						</IonLabel>
					</IonItem>
				</form>
			</IonList>
		</IonContent>
	</IonMenu>
);

const mapStateToProps = (state: RootState) => ({
  tokens: state.users.tokens,
  isLoggedIn: state.users.loggedIn,
});

export default connect(mapStateToProps)(ProfileMenu);
